import { PropsWithChildren } from 'react'
import ThreeDotsLoader from '../../../../Loaders/ThreeDotsLoader'

const PreviewLoader = ({ children }: PropsWithChildren) => {
  return (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 2,
      }}
    >
      {children ?? <ThreeDotsLoader />}
    </div>
  )
}

export default PreviewLoader
